import * as TYPES from './message-bar-actiontypes';
import * as MESSAGE_TYPES from './message-types';
import { persistStateToLocal, getStateFromLocal } from '../../webstorage';

export const LOCAL_STORAGE_KEY = 'patient:messageBar';


const initialState = {
  messageType: MESSAGE_TYPES.MESSAGE_TYPE_NONE,
  messageParameters: null,
  messageCode: '',
  keepDisplay: false,
};

const messageDisplayBarReducer = (state = initialState, action) => {
  let newState;
  let localState;
  switch (action.type) {
    case TYPES.MESSAGE_BAR_DISMISS:
      newState = { ...state, ...initialState };
      persistStateToLocal(LOCAL_STORAGE_KEY, newState);
      break;
    case TYPES.MESSAGE_BAR_DISPLAY:
    case TYPES.MESSAGE_BAR_FLAG:
      // If current message code === session timeout => don't overwrite.
      localState = getStateFromLocal(LOCAL_STORAGE_KEY, state);
      if (state.messageCode === 'sessiontimeout') {
        newState = state;
      } else if (localState.messageCode === 'sessiontimeout') {
        newState = localState;
      } else {
        newState = { ...state, ...action.state };
      }
      persistStateToLocal(LOCAL_STORAGE_KEY, newState);
      break;
    case TYPES.RETRIEVE_MESSAGE:
      newState = { ...state, ...getStateFromLocal(LOCAL_STORAGE_KEY, state) };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default messageDisplayBarReducer;
